import { useCallback } from 'react';

import {
  useAddUserToChatsMutation,
  useRemoveUserFromChatsMutation,
} from '../../../../../generated';

interface UseUpdateUserChatsProps {
  userId: string;
  onSuccess?: () => void;
}

export const useUpdateUserChats = ({
  userId,
  onSuccess,
}: UseUpdateUserChatsProps) => {
  const [addUserToChatsMutation, { loading: addLoading }] =
    useAddUserToChatsMutation({
      onCompleted: onSuccess,
    });

  const [removeUserFromChatsMutation, { loading: removeLoading }] =
    useRemoveUserFromChatsMutation({
      onCompleted: onSuccess,
    });

  const addUserToChats = useCallback(
    async (chatIds: string[]) => {
      await addUserToChatsMutation({
        variables: {
          userId,
          chatIds,
        },
      });
    },
    [addUserToChatsMutation, userId]
  );

  const removeUserFromChats = useCallback(
    async (chatIds: string[]) => {
      await removeUserFromChatsMutation({
        variables: {
          userId,
          chatIds,
        },
      });
    },
    [removeUserFromChatsMutation, userId]
  );

  return {
    addUserToChats,
    removeUserFromChats,
    loading: addLoading || removeLoading,
  };
};
